<template lang="pug">
  .component-backoffice-category-list.row.column
    .row
      .column.small-12.large-4.category(v-for="(category, index) in categories", v-on:click="setSearch(index)", :class="{ active: activeIndex === index}")
        .inner-content.card.text-center
          .row.p-1
            .column.shrink( v-if="activeIndex === index")
              dropdown(icon="fa fa-ellipsis-v fa-2x action", position="bottom", :key="`${$options.name}_${index}`")
                .dropdown-buttons
                  edit-vehicle-category(:item="category")
                  ActionButton(:action="deleteCategory", :confirm="true") Delete
                  requirement-modal(:entity_id="category.id", entity_type="VehicleCategory")
            .column.text-left
              small C{{category.id}}
              h2 {{ category.name }}

    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from "./BaseList";
import EditVehicleCategory from "../../components/structure/ui/actions/asset-management/EditVehicleCategory";
import MaggieHelper from "../../maggieHelper";
import Dropdown from "../../components/structure/foundation/Dropdown";
import RequirementModal from "../../components/structure/ui/actions/RequirementModal";
import ActionButton from "../../components/structure/ui/ActionButton";


export default {
  name: "CategoryList",
  components: {
    ActionButton,
    RequirementModal,
    Dropdown,
    EditVehicleCategory,
    BaseList,
  },
  data: function () {
    return {
      categories: [],
      activeIndex: null,
      search: null,
      emptyList: true,
      component: require('src/components/backoffice/Vehicle.vue'),
    }
  },
  created() {
    KeplerBackofficeSdk.vehicleCategories.list((data) => {
      this.categories = data;
      this.setSearch(0)
    })
  },
  methods: {
    setSearch(index) {

      if (this.activeIndex === index) {
        return
      }
      this.activeIndex = index
      this.search = {
        vehicle_category_id: this.categories[index].id
      }
    },
    deleteCategory() {
      return KeplerBackofficeSdk.vehicleCategories.select(this.categories[this.activeIndex].id).remove((data) => {
        MaggieHelper.notification('category', data.result_code)
      })
    },
    dataLoader(callback, page, resultsPerPage, search) {
      KeplerBackofficeSdk.vehicles.list(page, resultsPerPage).all(search, (items) => {
        this.emptyList = items.items_count === 0
        callback(items)
      })
    },
  },
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CategoryList.vue?6fc4b6ec